import React, { useState, useEffect } from "react";
import axiosClient from "../../service/axios";
import { SyncOutlined } from "@ant-design/icons";
import DeclinedQuotations from "./DeclinedQuotations";
import Search from "../../components/search";

const DeclinedQuotationItem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const declineHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get(
        "lite/v2/api/admin/failed/quotations/declined"
      );

      const responseData = response?.data?.data;
      // console.log(responseData, "response");
      setData(responseData);
      setLoading(false);
    } catch (error) {
      console.log("error is decline");
    }
  };

  useEffect(() => {
    declineHandler();
  }, []);

  const filteredData = data.filter((row) =>
    row?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <div>
        <Search placeholder="Find Any Order..." onChange={handleSearch} />
      </div>

      <div>
        {filteredData.length > 0 ? (
          filteredData.map((item, index) => (
            <DeclinedQuotations
              key={index}
              // agent={item.agent}
              id={item.id}
              channel={item.channel}
              // vendor_id={item.vendor_id}
              // discount={item.discount}
              // dispatch={item.dispatch}
              order_by={item.order_by}
              // order_id={item.order_id}
              // order_state={item.order_state}
              // payment={item.payment}
              // requester={item.requester}
              // decline_by={item.decline_by}
              status={item.status}
              // total={item.total}
              // bgColor={item.bgColor}
              color={item.color}
              // icon={item.icon}
              quipOrStock={item.quipOrStock}
              rejection_reason={item.rejection_reason}
              // reason={item.reason}
              fone={item.fone}
              // personnel_name={item.personnel_name}
              // order_amt={item.order_amt}
              // qty={item.qty}
              name={item.name}
              // address={item.address}
              // city={item.city}
              // state={item.state}
              // order_source={item.order_source}
              tym={item.tym}
              secondcheck={item.secondcheck}
              // size={item.size}
              // constructOrderDate={item.constructOrderDate}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            {loading ? <SyncOutlined spin /> : "Items Not Available"}
          </div>
        )}
      </div>
    </>
  );
};

export default DeclinedQuotationItem;
